import MetricDetailGroupService from '@/pages/benchmark/pages/metricDetail/components/MetricDetailGroupService';
import MetricDetailTableService from '@/pages/benchmark/pages/metricDetail/components/MetricDetailTableService';

export default {
  MetricDetailTableService,
  MetricDetailGroupService
};
